import Skeleton, { StyledSkeleton } from './Skeleton'
export { StyledSkeleton }
export default Skeleton
